export enum FieldTypes
{
  TEXT     = 'text',
  PASSWORD = 'password',
  CHECKBOX = 'checkbox',
  RADIO    = 'radio',
  DROPDOWN = 'dropdown'
}
